import { ScreenerView } from "../../model/careScreenerModels";
import { CompleteCareScreenerResponse } from "../../services/CareScreenerService";

export type AccountCreationInterruption = ScreenerView.CARE_TEAM_FOLLOW_UP | ScreenerView.TWO_FACTOR_AUTH;

/**
 * The views that take over right after account creation, before any scheduling logic runs: a
 * family the care team must finish, or a second factor still to verify. Anything else continues
 * into the normal completion flow.
 */
export function accountCreationInterruption(
  result: Pick<CompleteCareScreenerResponse, "careTeamFollowUp" | "challengeToken">
): AccountCreationInterruption | undefined {
  if (result.careTeamFollowUp) return ScreenerView.CARE_TEAM_FOLLOW_UP;
  if (result.challengeToken) return ScreenerView.TWO_FACTOR_AUTH;
  return undefined;
}
